import { render } from "./MenuForFour.vue?vue&type=template&id=45112e86&scoped=true"
import script from "./MenuForFour.vue?vue&type=script&lang=js"
export * from "./MenuForFour.vue?vue&type=script&lang=js"

import "./MenuForFour.vue?vue&type=style&index=0&id=45112e86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45112e86"]])

export default __exports__